import {DishDetailsItem} from "@apps/dish/interfaces";
import moment from "moment";

import {eatClubClient} from "@globals/config/apiClient";
import {
  DateString,
  ObjectWithAnyProps,
  ResponseError,
} from "@globals/types/utilityTypes";

import {Menu, MenuType} from "@components/Menu/interfaces";

import {Brand} from "./interfaces";

export function handleError(
  response: ObjectWithAnyProps,
  subMessage: string
): ResponseError {
  return {
    status: response.status,
    message: response.data?.message,
    subMessage,
  };
}

export function fetchBrand(
  operatorSlug: string,
  restaurantSlug: string
): Promise<Brand> {
  return eatClubClient
    .get(`/restaurants/${operatorSlug}/${restaurantSlug}/info/`)
    .then((response) => response.data)
    .catch(({response}) => {
      const error = handleError(response, "brand's info");
      throw error;
    });
}

export function fetchBrandDishes(
  operatorSlug: string,
  restaurantSlug: string
): Promise<DishDetailsItem[]> {
  return eatClubClient
    .get(`/restaurants/${operatorSlug}/${restaurantSlug}/dishes/`)
    .then((response) => response.data)
    .catch(({response}) => {
      const error = handleError(response, "brand's dishes");
      throw error;
    });
}

export function fetchBrandMenu(
  operatorSlug: string,
  restaurantSlug: string,
  menuDate: DateString
): Promise<Menu> {
  // Returns menu item ids for item ids in response.items
  return eatClubClient
    .get("/menus/", {
      params: {
        date: menuDate,
        menu_type: MenuType.Brand,
        tenant_slug: operatorSlug,
        restaurant_slug: restaurantSlug,
      },
    })
    .then((response) => response.data)
    .catch(({response}) => {
      const displayDate = moment(menuDate).format("ddd M/D");
      const error = handleError(response, `menu for ${displayDate}`);
      throw error;
    });
}
